import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "new-message-form__input" }
const _hoisted_3 = { class: "new-message-form__emoji-picker" }
const _hoisted_4 = {
  key: 2,
  class: "new-message-form__quote"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NewMessageTypingIndicator = _resolveComponent("NewMessageTypingIndicator")
  const _component_NewMessageAttachments = _resolveComponent("NewMessageAttachments")
  const _component_NewMessageAbsenceInfo = _resolveComponent("NewMessageAbsenceInfo")
  const _component_NewMessageChatSummary = _resolveComponent("NewMessageChatSummary")
  const _component_IconEmoticonOutline = _resolveComponent("IconEmoticonOutline")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NcEmojiPicker = _resolveComponent("NcEmojiPicker")
  const _component_MessageQuote = _resolveComponent("MessageQuote")
  const _component_NcNoteCard = _resolveComponent("NcNoteCard")
  const _component_NcTextField = _resolveComponent("NcTextField")
  const _component_NcRichContenteditable = _resolveComponent("NcRichContenteditable")
  const _component_IconBellOffOutline = _resolveComponent("IconBellOffOutline")
  const _component_NcActionButton = _resolveComponent("NcActionButton")
  const _component_NcActions = _resolveComponent("NcActions")
  const _component_NewMessageAudioRecorder = _resolveComponent("NewMessageAudioRecorder")
  const _component_IconClose = _resolveComponent("IconClose")
  const _component_IconCheck = _resolveComponent("IconCheck")
  const _component_IconForumOutline = _resolveComponent("IconForumOutline")
  const _component_IconSend = _resolveComponent("IconSend")
  const _component_NewMessageNewFileDialog = _resolveComponent("NewMessageNewFileDialog")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.showTypingStatus)
      ? (_openBlock(), _createBlock(_component_NewMessageTypingIndicator, {
          key: 0,
          token: $props.token
        }, null, 8, ["token"]))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      id: "file-upload",
      ref: "fileUploadInput",
      multiple: "",
      type: "file",
      tabindex: "-1",
      "aria-hidden": "true",
      class: "hidden-visually",
      onChange: _cache[0] || (_cache[0] = (...args) => ($options.handleFileInput && $options.handleFileInput(...args)))
    }, null, 544),
    _createElementVNode("form", {
      class: "new-message-form",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
    }, [
      ($options.showAttachmentsMenu)
        ? (_openBlock(), _createBlock(_component_NewMessageAttachments, {
            key: 0,
            token: $props.token,
            disabled: $options.disabled,
            "can-upload-files": $options.canUploadFiles,
            "can-share-files": $options.canShareFiles,
            "can-create-poll": $options.canCreatePoll,
            "can-create-thread": $options.canCreateThread,
            onOpenFileUpload: $options.openFileUploadWindow,
            onCreateThread: $options.setCreateThread,
            onHandleFileShare: $options.showFilePicker,
            onUpdateNewFileDialog: $options.updateNewFileDialog
          }, null, 8, ["token", "disabled", "can-upload-files", "can-share-files", "can-create-poll", "can-create-thread", "onOpenFileUpload", "onCreateThread", "onHandleFileShare", "onUpdateNewFileDialog"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (!$props.dialog && $options.userAbsence)
          ? (_openBlock(), _createBlock(_component_NewMessageAbsenceInfo, {
              key: 0,
              "user-absence": $options.userAbsence,
              "display-name": $options.conversation.displayName
            }, null, 8, ["user-absence", "display-name"]))
          : _createCommentVNode("", true),
        (!$props.dialog && $options.showChatSummary)
          ? (_openBlock(), _createBlock(_component_NewMessageChatSummary, { key: 1 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          (!$options.disabled)
            ? (_openBlock(), _createBlock(_component_NcEmojiPicker, {
                key: 0,
                "keep-open": "",
                "set-return-focus": $options.getContenteditable,
                onSelect: $options.addEmoji
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_NcButton, {
                    disabled: $options.disabled,
                    variant: "tertiary",
                    "aria-label": $options.t('spreed', 'Add emoji'),
                    "aria-haspopup": true
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_IconEmoticonOutline, { size: 20 })
                    ]),
                    _: 1
                  }, 8, ["disabled", "aria-label"])
                ]),
                _: 1
              }, 8, ["set-return-focus", "onSelect"]))
            : (_openBlock(), _createBlock(_component_NcButton, {
                key: 1,
                variant: "tertiary",
                "aria-label": $options.t('spreed', 'Add emoji'),
                disabled: true
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconEmoticonOutline, { size: 20 })
                ]),
                _: 1
              }, 8, ["aria-label"]))
        ]),
        ($options.parentMessage || $options.messageToEdit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_MessageQuote, {
                message: $options.messageToEdit ?? $options.parentMessage,
                "can-cancel": !!$options.parentMessage,
                "edit-message": !!$options.messageToEdit
              }, null, 8, ["message", "can-cancel", "edit-message"])
            ]))
          : _createCommentVNode("", true),
        ($options.showMentionEditHint)
          ? (_openBlock(), _createBlock(_component_NcNoteCard, {
              key: 3,
              type: "warning",
              text: $options.t('spreed', 'Adding a mention will only notify users who did not read the message.')
            }, null, 8, ["text"]))
          : _createCommentVNode("", true),
        ($options.threadCreating)
          ? (_openBlock(), _createBlock(_component_NcTextField, {
              key: 4,
              ref: "threadTitleInputRef",
              modelValue: $options.threadTitle,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($options.threadTitle) = $event)),
              class: "new-message-form__thread-title",
              label: $options.t('spreed', 'Thread title'),
              disabled: $options.disabled,
              error: !!$data.errorTitle,
              title: $data.errorTitle,
              "show-trailing-button": "",
              onTrailingButtonClick: _cache[2] || (_cache[2] = $event => ($options.setCreateThread(false)))
            }, null, 8, ["modelValue", "label", "disabled", "error", "title"]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_component_NcRichContenteditable, {
          ref: "richContenteditable",
          key: $props.container,
          modelValue: $data.text,
          "onUpdate:modelValue": [
            _cache[3] || (_cache[3] = $event => (($data.text) = $event)),
            $options.handleTyping
          ],
          class: _normalizeClass({ 'new-message-form__input-rich--required': $data.errorMessage }),
          title: $data.errorMessage,
          "auto-complete": $setup.autoComplete,
          disabled: $options.disabled,
          "user-data": $setup.userData,
          "menu-container": $options.containerElement,
          placeholder: $options.placeholderText,
          "aria-label": $options.placeholderText,
          dir: $data.text ? 'auto' : undefined,
          onKeydown: [
            _withKeys($options.handleInputEsc, ["esc"]),
            _withKeys(_withModifiers($options.handleEditLastMessage, ["ctrl"]), ["up"]),
            _withKeys(_withModifiers($options.handleEditLastMessage, ["meta"]), ["up"])
          ],
          onPaste: $options.handlePastedFiles,
          onFocus: $options.restoreSelectionRange,
          onBlur: $options.preserveSelectionRange,
          onSubmit: $options.handleSubmit
        }, null, 8, ["modelValue", "class", "title", "auto-complete", "disabled", "user-data", "menu-container", "placeholder", "aria-label", "dir", "onKeydown", "onUpdate:modelValue", "onPaste", "onFocus", "onBlur", "onSubmit"]))
      ]),
      ($options.showSilentToggle)
        ? (_openBlock(), _createBlock(_component_NcActions, {
            key: 1,
            "force-menu": "",
            primary: $data.silentChat
          }, {
            icon: _withCtx(() => [
              ($data.silentChat)
                ? (_openBlock(), _createBlock(_component_IconBellOffOutline, {
                    key: 0,
                    size: 20
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_NcActionButton, {
                "close-after-click": "",
                "model-value": $data.silentChat,
                description: $options.silentSendInfo,
                onClick: $options.toggleSilentChat
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconBellOffOutline, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($options.silentSendLabel) + " ", 1)
                ]),
                _: 1
              }, 8, ["model-value", "description", "onClick"])
            ]),
            _: 1
          }, 8, ["primary"]))
        : _createCommentVNode("", true),
      ($options.showAudioRecorder)
        ? (_openBlock(), _createBlock(_component_NewMessageAudioRecorder, {
            key: 2,
            disabled: $options.disabled,
            onRecording: $options.handleRecording,
            onAudioFile: $options.handleAudioFile
          }, null, 8, ["disabled", "onRecording", "onAudioFile"]))
        : ($options.messageToEdit)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createVNode(_component_NcButton, {
                variant: "tertiary",
                type: "submit",
                title: $options.t('spreed', 'Cancel editing'),
                "aria-label": $options.t('spreed', 'Cancel editing'),
                onClick: $options.handleAbortEdit
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconClose, { size: 20 })
                ]),
                _: 1
              }, 8, ["title", "aria-label", "onClick"]),
              _createVNode(_component_NcButton, {
                disabled: $options.disabledEdit,
                variant: "tertiary",
                type: "submit",
                title: $options.t('spreed', 'Edit message'),
                "aria-label": $options.t('spreed', 'Edit message'),
                onClick: $options.handleEdit
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconCheck, { size: 20 })
                ]),
                _: 1
              }, 8, ["disabled", "title", "aria-label", "onClick"])
            ], 64))
          : (_openBlock(), _createBlock(_component_NcButton, {
              key: 4,
              disabled: $options.disabled,
              variant: "tertiary",
              type: "submit",
              title: $options.sendMessageLabel,
              "aria-label": $options.sendMessageLabel,
              onClick: $options.handleSubmit
            }, {
              icon: _withCtx(() => [
                ($options.threadCreating)
                  ? (_openBlock(), _createBlock(_component_IconForumOutline, {
                      key: 0,
                      size: 20
                    }))
                  : (_openBlock(), _createBlock(_component_IconSend, {
                      key: 1,
                      class: "bidirectional-icon",
                      size: 20
                    }))
              ]),
              _: 1
            }, 8, ["disabled", "title", "aria-label", "onClick"]))
    ], 32),
    ($data.showNewFileDialog !== -1)
      ? (_openBlock(), _createBlock(_component_NewMessageNewFileDialog, {
          key: 1,
          token: $props.token,
          "show-new-file-dialog": $data.showNewFileDialog,
          onDismiss: _cache[5] || (_cache[5] = $event => ($data.showNewFileDialog = -1))
        }, null, 8, ["token", "show-new-file-dialog"]))
      : _createCommentVNode("", true)
  ]))
}